module.exports = __webpack_public_path__ + "img/right-down-butterfly.9b9cdef2.svg";